import React from 'react';
import { useDispatch } from 'react-redux';

import { Props } from './NavigationButton.types';
import { Styled } from './NavigationButton.styles';
import { actions } from '../../../../../reducer/user';
import outIcon from '../../../../../images/sign-out.svg';

export const LogoutButton: React.FC<Props> = () => {
  const dispatch = useDispatch();

  return (
    <Styled.LogoutButton>
      <img
        onClick={() => dispatch(actions.logOut())}
        alt="Выход"
        src={outIcon}
      />
    </Styled.LogoutButton>
  );
};
